<script setup lang="ts">
/**
 * CaLangkah — 3 langkah bernomor: "apa yang terjadi setelah saya bayar".
 *
 * Untuk audiens yang belum pernah membeli apa pun dari situs yang tidak
 * dikenalnya, ini bagian terpenting kedua setelah harga. Nomor dirender
 * sebagai <ol> supaya pembaca layar ikut menyebut urutannya, bukan sekadar
 * lingkaran gold yang kebetulan berisi angka.
 *
 * `runtun`: memunculkan langkah satu per satu saat bagian ini masuk layar
 * (data-muncul per <li> + kelas .ca-runtun pada <ol>). Aman dari tabrakan
 * `transform` karena langkah TIDAK ikut tilt — beda dengan grid alat. Garis
 * penghubung antar-langkah ikut memudar masuk bersama langkahnya, sehingga
 * "1 → 2 → 3" seolah tersambung berurutan. Bila JS gagal/dimatikan, seluruh
 * langkah tetap tampil utuh (lihat useGerak.ts catatan a).
 */
defineProps<{
  langkah: { judul: string; detail: string; ikon: string }[]
  /** Munculkan langkah berurutan saat digulir + tampilkan garis penghubung. */
  runtun?: boolean
}>()
</script>

<template>
  <ol :class="['grid gap-4 sm:gap-5 md:grid-cols-3', runtun ? 'ca-runtun' : '']">
    <li
      v-for="(l, i) in langkah"
      :key="l.judul"
      :data-muncul="runtun ? '' : undefined"
      class="relative flex gap-4 md:flex-col md:gap-3"
    >
      <!-- Garis penghubung ke langkah berikutnya. Dekoratif; posisinya diatur
           responsif di gerak.css (tegak di HP, mendatar di desktop). -->
      <span v-if="i < langkah.length - 1" class="ca-langkah-garis" aria-hidden="true" />

      <div class="relative z-[1] flex shrink-0 items-center gap-3">
        <span
          class="ca-ikon-emas ca-num grid place-items-center size-10 shrink-0 rounded-full text-base font-extrabold"
          aria-hidden="true"
        >{{ i + 1 }}</span>
        <UIcon :name="l.ikon" class="size-5 text-brand hidden md:block" aria-hidden="true" />
      </div>

      <div class="min-w-0">
        <p class="font-bold text-ink leading-snug">{{ l.judul }}</p>
        <p class="mt-1.5 text-sm text-muted leading-relaxed">{{ l.detail }}</p>
      </div>
    </li>
  </ol>
</template>
